module.exports = __webpack_public_path__ + "static/media/39-8.e0cfa493.mp3";